import React from 'react'
import { AgGridReact } from "ag-grid-react";
import ModalBasic from '../../component/ModalBasic';
import TextInput from '../../../components/UIComponent/TextInput';
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';

const itemColdefs = [
    {
        field: "drawingNo",
        headerName: "Drawing no",
        minWidth: window.innerWidth * 0.12,
        flex: 0.9,
        filter: true,
    },
    {
        field: "materialType",
        headerName: "Item type",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    {
        field: "rejectionNo",
        headerName: "Rejection no",
        minWidth: window.innerWidth * 0.07,
        flex: 0.7,
        filter: true,
    },
    {
        field: "itemName",
        headerName: "Item details",
        minWidth: window.innerWidth * 0.2,
        flex: 2,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "weight",
        headerName: "Weight (KG)",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "rate",
        headerName: "Rate (₹)",
        minWidth: window.innerWidth * 0.07,
        flex: 0.6,
        filter: true,
    },
    {
        field: "remarks",
        headerName: "Remarks",
        minWidth: window.innerWidth * 0.08,
        flex: 0.8,
        filter: true,
    },
];

export const MaterialRejectionOutwardPopup = (props) => {
    return (
        <ModalBasic
            id="material-rejection-outward"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Material rejection outward details</span>
                <div className='item-grp grid grid-cols-4 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Rejection outward no</label>
                        <TextInput type='text'
                            id='rejectionNo' name='rejectionNo'
                            value={props.materialObject.rejectionNo}
                            handleChange={(event) => props.handleChangeForPurchase(event, 'rejectionNo')}
                            className={props.validState?.error?.rejectionNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rejection outward date</label>
                        <TextInput type='date'
                            id='rejectionDate' name='rejectionDate'
                            value={props.materialObject.rejectionDate}
                            handleChange={(event) => props.handleChangeForPurchase(event, 'rejectionDate')}
                            className={props.validState?.error?.rejectionDate !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Auth. employee</label>
                        <TextInput type='text'
                            id='usp_Users' name='usp_Users'
                            value={props.usp_Users.find(x => x.globalUserID === props.globalUserID)?.userName || ''}
                            disabled={true}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Select material</label>
                        <MultiSelectDropdown
                            drpIdentity="Select material"
                            options={props.materialList}
                            value={props.materialObject.idMaterial ? props.materialList.find(x => x.value === props.materialObject.idMaterial) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idMaterial", 'materialObject')
                            }
                            className={props.validState?.error?.idMaterial !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp col-span-3'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.materialObject.remarks}
                            handleChange={(event) => props.handleChangeForPurchase(event, 'remarks')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label className="invisible">Is approve</label>
                        <div className="flex items-center gap-2 h-[40px]">
                            <input
                                type="checkbox"
                                id="isApprove"
                                checked={props.materialObject.isApprove || false}
                                onChange={(event) => props.handleApproveChange(event)}
                                className="w-4 h-4 cursor-pointer"
                            />
                            <label htmlFor="isApprove" className="!mb-0 cursor-pointer">Is approve</label>
                        </div>
                    </div>
                </div>
                <span className="text-blue text-[16px] font-semibold">Item details</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Drawing no</label>
                        <TextInput type='text'
                            id='drawingNo' name='drawingNo'
                            value={props.itemObject.drawingNo}
                            handleChange={(event) => props.handleChangeForItem(event, 'drawingNo')}
                            className={props.validState?.error?.drawingNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Select type</label>
                        <MultiSelectDropdown
                            drpIdentity="Select type"
                            options={props.itemObject.TypeList}
                            value={props.itemObject.idType ? props.itemObject.TypeList.find(x => x.value === props.itemObject.idType) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idType", 'itemObject')
                            }
                            className={props.validState?.error?.idType !== undefined ? "error" : ""}
                            isDisabled={true}
                        />
                    </div>
                    <div className='input-grp col-span-2'>
                        <label>Item name</label>
                        {/* <MultiSelectDropdown
                            drpIdentity="Select priority"
                            options={props.itemObject.ItemList}
                            value={props.itemObject.idItem ? props.itemObject.ItemList.find(x => x.value === props.itemObject.idItem) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idItem", 'itemObject')
                            }
                            className={props.validState?.error?.idItem !== undefined ? "error" : ""}
                        /> */}
                        <TextInput
                            id="SelectItem"
                            name="SelectItem"
                            value={props.itemObject.itemIdLabel}
                            handleOnClick={(event) => props.handleOnClick(event, "itemList")}
                            disabled={props.materialObject.idMaterial > 0 ? false : true}
                        // className={props.validState?.error?.chequeBookSeries !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rejection no</label>
                        <TextInput type='text'
                            id='rejectionNo' name='rejectionNo'
                            value={props.itemObject.rejectionNo}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Quantity</label>
                        <TextInput type='number'
                            id='quantity' name='quantity'
                            value={props.itemObject.quantity}
                            handleChange={(event) => props.handleChangeForItem(event, 'quantity')}
                            className={props.validState?.error?.quantity !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Weight (KG)</label>
                        <TextInput type='number'
                            id='weight' name='weight'
                            value={props.itemObject.weight}
                            handleChange={(event) => props.handleChangeForItem(event, 'weight')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Rate (₹)</label>
                        <TextInput type='number'
                            id='rate' name='rate'
                            value={props.itemObject.rate}
                            handleChange={(event) => props.handleChangeForItem(event, 'rate')}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Remarks</label>
                        <TextInput type='text'
                            id='remarks' name='remarks'
                            value={props.itemObject.remarks}
                            handleChange={(event) => props.handleChangeForItem(event, 'remarks')}
                            className={props.validState?.error?.remarks !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='btn-grp flex gap-2.5 col-span-2 mt-5'>
                        {props.itemObject.keyId > 0 ?
                            <button className="save-btn btns py-[10px] px-[20px]" onClick={() => props.insert("Update")}>Update</button>
                            :
                            <button className="save-btn btns py-[10px] px-[20px]" onClick={() => props.insert("Insert")}>Insert</button>
                        }
                        <button className="edit-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.clearItemObject()}>Clear</button>
                        <button className="delete-btn btns py-[10px] px-[20px] h-[40px]" onClick={() => props.delete(props.itemObject.keyId)}>Delete</button>
                    </div>
                </div>
                <div className="register-table h-[40vh]">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            onCellClicked={props.onItemRowDataClicked}
                            // onGridReady={props.onGridReady}
                            overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                            overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-grp flex gap-2.5 mt-5'>
                    <button className="update-btn btns" onClick={() => props.submit()} disabled={props.isSaving}>Save</button>
                    {/* <button className="print-btn btns">Print</button>
                    <button className="edit-btn btns">Preview</button> */}
                    <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                </div>
            </div>

        </ModalBasic>
    )
}